"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeAddress = void 0;
const City_1 = require("./homeaddress/City");
const Country_1 = require("./homeaddress/Country");
const PostalCode_1 = require("./homeaddress/PostalCode");
const StreetAddress_1 = require("./homeaddress/StreetAddress");
exports.HomeAddress = {
    city: City_1.City,
    country: Country_1.Country,
    postal_code: PostalCode_1.PostalCode,
    street_address: StreetAddress_1.StreetAddress,
};
